import { render, staticRenderFns } from "./FlashNewsCreateView.vue?vue&type=template&id=44833254&"
import script from "./FlashNewsCreateView.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44833254')) {
      api.createRecord('44833254', component.options)
    } else {
      api.reload('44833254', component.options)
    }
    module.hot.accept("./FlashNewsCreateView.vue?vue&type=template&id=44833254&", function () {
      api.rerender('44833254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/flashNews/FlashNewsCreateView.vue"
export default component.exports